import React, { useState, useEffect, useRef } from "react";
import { sbaAxios } from "../../utils/sbaAxios";
import { TopBar } from "../../shared/topBar/TopBar";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { UrlPath } from "../../../config/routeConfig";
import { DateRangePicker } from "rsuite";
import {
    getCustomSettings, getClientReportSettings, deleteReportSettings, getClientStatementAPI,
    getClassificationItemsReportinsetting, getAssetWithoutReportSettings, insertOrUpdateReportSettings,getReportClassificationsAPI, deleteSubMenuToRole
} from "../../../config/apiConfig";
import moment from "moment";
import { SBADropDown, SBAMultiSelectCheck, SBAComboBox } from "../../UiComponents/SBADropDown";
import { getPortfolioListAction } from '../../actions/portfolioListAction'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { SBGrid } from "../../UiComponents/SBAAGgrid";
import { SBADrawer } from "../../UiComponents/SBADrawer";
import { SBNotify } from "../../utils/sbNotify";
import { ToastContainer, toast } from 'react-toastify';
import { Modal } from "react-bootstrap";
import { SBDatePicker } from "../../UiComponents/SBDatePicker";
export const ClientReportingSettings = () => {
  const usersLastLoginRef = useRef();
    const Gstate = useSelector((state) => state) || {};
    const dispatch = useDispatch();
    const history = useNavigate();
    const getPortfolioList = useSelector(state => state?.portfolioList?.portfolioList) || [];
    const [render, setRender] = useState(true);
    const [GridData, setGridData] = useState([]);
    const [selectedPortfolio, setselectedPortfolio] = useState([]);
    const [colDef, setColDef] = useState([])
    const [appliedFilter, setAppliedFilter] = useState({})
    const [showdeleteModal, setShowdeleteModal] = useState(false);
    const [deletedclientid, setdeletedclientid] = useState([]);
    const [Editdata, setEditdata] = useState(Editflages);
    const [DrawerPortfolio, setDrawerPortfolio] = useState([]);
    const [AssetData, setAssetData] = useState([]);
    const [statergydata, setstatergydata] = useState([]);
    const [substatergydata, setsubstatergydata] = useState([]);
    const [selectedAsset, setselectedAsset] = useState([]);
    const [selectedstatergy, setselectedstatergy] = useState([]);
    const [selectedsubstatergy, setselectedsubstatergy] = useState([]);
    const [selectedAssetnameoverride, setselectedAssetnameoverride] = useState([]);
    const [selectedLinking, setselectedLinking] = useState("");
    const [CSData, setCSData] = useState([]);
    const [selectedCSData, setselectedCSData] = useState([]); 
    const [newDate, setNewDate] = useState(null);
    const [iseditable, setiseditable] = useState(false);
    const [clientstmtId, setclientstmtId] = useState([]);
    const [Classificationdata, setClassificationdata] = useState([]);
    const [selectedReportClassification, setselectedReportClassification] = useState([]);
    const [show, setshow] = useState(false);
    useEffect(() => {
        dispatch(getPortfolioListAction());
        GetReportClassificationsAPI();
    }, []);
    useEffect(() => {
      document.title = `Client Reporting Settings`;
       
        Getsubstatergy();
        fetchGridData();
       Getstatergy();
       getClientStatementData();     
       GetClientReportSettings(selectedPortfolio?.PortfolioId)
        setRender(false);

   }, []);

    const enterButtonClick = () => {
        fetchGridData();
        GetClientReportSettings(selectedPortfolio.PortfolioId, selectedReportClassification.ReportClassificationId)
  };
  const Addbuttonclk = () => {
      if (selectedPortfolio.length !== 0 && selectedReportClassification.length !== 0) {
          setiseditable(false);
          setclientstmtId(0)
          setDrawerPortfolio(selectedPortfolio);
          GetAsset(selectedPortfolio.PortfolioId,selectedReportClassification.ReportClassificationId);
          setselectedAsset([]);
          setselectedstatergy([]);
          setselectedsubstatergy([]);
          setselectedAssetnameoverride("");
          setselectedLinking([]);
          setEditdata(Editflages);
          setselectedLinking("")
          setselectedCSData([]);
          setshow(true);
          setNewDate(null);
      }
      else {

          SBNotify({ Msg: "Please choose Report Classification And Portfolio", type: "error" });
      }
    }
  let Level = [{ BreadCrumb: "Admin > ", Routes: `${UrlPath.Admin}` }];
  Level = render
    ? Level
    : [
        ...Level,
        {
            BreadCrumb: `Client Reporting Settings`,
            Routes: `${UrlPath.ClientReportingSetting}`,
        },
        ];
    const checkBoxFormatter = (params) => {
        return <input type='checkbox' checked={params.value === true} />;
    };
    const valuformaterapply = (params) => {
        const isoDate = params.value;
        return isoDate ? moment(isoDate).format("MM-DD-YYYY") : "";
    }
    const Deletesettings = () => {
        sbaAxios({ url: `${deleteReportSettings}/${deletedclientid}` })
            .then((res) => {

                SBNotify({
                    Msg: "Selected Settings Deleted Successfully",
                    type: "success",
                });
                setShowdeleteModal(false);
                GetClientReportSettings(selectedPortfolio.PortfolioId,selectedReportClassification.ReportClassificationId)
            })
            .catch((error) => {
                SBNotify({ Msg: error, type: "error" });
            });
    };

    const SaveReportsettings = () => {    
        let ifsave = true;
        const savedata = {
            "clientReportSettingId": clientstmtId,
            "reportClassificationId": selectedReportClassification.ReportClassificationId,
            "isDefault": Editdata.IsDefault,
            "portfolioId": DrawerPortfolio.PortfolioId,
            "assetId": selectedAsset.AssetId,
            "assetNameOverride": selectedAssetnameoverride ? selectedAssetnameoverride:"",
            "inceptionDateOverride": newDate ? newDate: null,
            "primaryClassificationId": selectedstatergy.ClassificationId,
            "secondaryClassificationId": selectedsubstatergy.ClassificationId,
            "isPerforming": Editdata.Performing,
            "isAdvised": Editdata.Advised,
            "isBillable": Editdata.Billable,
            "useAssetNameForPortfolio": Editdata.Useasset,
            "isSMA": Editdata.Sma,
            "hideDetails": Editdata.Hidedetails,
            "primaryCash": Editdata.Primarycash,
            "discretionary": Editdata.Discretionary,
            "regulatoryAum": Editdata.RegulatoryAum,
            "linkingPortfolios": selectedLinking ? selectedLinking:"",
            "clientStatementId": selectedCSData.ClientStatementId ? selectedCSData.ClientStatementId:0
        }
        if (!DrawerPortfolio.PortfolioId) {
            ifsave = false;
            SBNotify({ Msg: " Please Select Portfolio ", type: "error" });
        }
        if (!selectedAsset.AssetId) {
            ifsave = false;
            SBNotify({ Msg: " Please Select Asset ", type: "error" });
        }
        if (!selectedstatergy.ClassificationId || selectedstatergy.ClassificationId === 0 || selectedstatergy.ClassificationId === undefined) {
            ifsave = false;
            SBNotify({ Msg: " Please Select Statergy ", type: "error" });
        }
        if (!selectedsubstatergy.ClassificationId || selectedsubstatergy.ClassificationId === 0 || selectedsubstatergy.ClassificationId === undefined) {
            ifsave = false;
            SBNotify({ Msg: " Please Select Sub Statergy ", type: "error" });
        }
        if (ifsave) {

            sbaAxios({
                url: `${insertOrUpdateReportSettings}`,
                method: "post",
                data: savedata
            }).then((res) => {
                SBNotify({
                    Msg: " Client Reporting Settings Save Successfully",
                    type: "success",
                });
                setshow(false);
                if (iseditable === false) {
                    setselectedPortfolio(DrawerPortfolio);
                }
                GetClientReportSettings(DrawerPortfolio.PortfolioId,selectedReportClassification.ReportClassificationId)
            })
                .catch((error) => {
                    SBNotify({ Msg: error, type: "error" });
                });
        }
    };
    const ActionRenderer = (props) => {   
        const deletedclientid = props.data.ClientReportSettingId;
        const Editdatas = props.data;
        const handleDeleteClick = () => {
            setShowdeleteModal(true);
            setdeletedclientid(deletedclientid);
        };
        const handleEditClick = () => {       
            setiseditable(true);
            setDrawerPortfolio({ "PortfolioId": Editdatas.PortfolioId, "Name": Editdatas.PortfolioName})
            setselectedAsset({ "AssetName": Editdatas.AssetName, "AssetId": Editdatas.AssetId})
            setselectedstatergy({ "ClassificationId": Editdatas.PrimaryClassificationId, "ClassificationValue": Editdatas.PrimaryClassification })
            setselectedsubstatergy({ "ClassificationId": Editdatas.SecondaryClassificationId, "ClassificationValue": Editdatas.SecondaryClassification })
            setselectedCSData({ "ClientStatementId": Editdatas.ClientStatementId, "ClientStatementName": Editdatas.ClientStatementName})
            setselectedAssetnameoverride(Editdatas.AssetNameOverride)
            setclientstmtId(Editdatas.ClientReportSettingId)
            setselectedLinking(Editdatas.LinkingPortfolios)
             setEditdata(prevData => ({
                Performing: Editdatas.IsPerforming,
                Billable: Editdatas.IsBillable,
                Advised: Editdatas.IsAdvised,
                Useasset: Editdatas.UseAssetNameForPortfolio,
                Sma: Editdatas.IsSMA,
                Hidedetails: Editdatas.HideDetails,
                Primarycash: Editdatas.PrimaryCash,
                IsDefault: Editdatas.IsDefault,
                Discretionary: Editdatas.Discretionary,
                RegulatoryAum:Editdatas.RegulatoryAum


            }));
            setNewDate(Editdatas?.InceptionDateOverride ? moment(Editdatas?.InceptionDateOverride) : null);
            setshow(true);
        };
        return (
            <div className="actions-cell">
                <i className="fas fa-trash" style={{ color: "#DF001B", margin: "0 8px", cursor: "pointer" }} onClick={handleDeleteClick}></i>
                <i
                    className="fas fa-edit"
                    style={{ color: "#47A547", margin: "0 8px", cursor: "pointer" }}
                    onClick={handleEditClick}
                ></i>
            </div>                        
        );
    };
    const getCustomSetting = async () => {
        try {
            const response = await sbaAxios({ url: `${getCustomSettings}1021` });
            if (response) {
                const apiColDef = JSON.parse(response.CustomSettingsValue);
                const filterOptions = response.CustomFilterValue.trim() !== "" ? JSON.parse(response.CustomFilterValue) : null;
                const formattedDef = apiColDef.map(item => ({
                    ...item,
                    "field": item.colId,
                    cellRenderer: item.colId === "IsDefault" ? checkBoxFormatter :
                  item.colId === "IsPerforming" ? checkBoxFormatter :
                  item.colId === "IsAdvised" ? checkBoxFormatter :
                  item.colId === "IsBillable" ? checkBoxFormatter :
                  item.colId === "IsSMA" ? checkBoxFormatter :
                  item.colId === "HideDetails" ? checkBoxFormatter :
                  item.colId === "UseAssetNameForPortfolio" ? checkBoxFormatter :
                  item.colId === "PrimaryCash" ? checkBoxFormatter :
                  item.colId === "Discretionary" ? checkBoxFormatter :
                  item.colId === "RegulatoryAum" ? checkBoxFormatter :
                  item.colId === "InceptionDateOverride" ? valuformaterapply : null,
                      "headerName": item.colId === "PortfolioName" ? "Portfolio Name" : item.colId === "AssetName" ? "Asset Name" :
                      item.colId === "AssetNameOverride" ? "Asset Name Override" :
                      item.colId === "InceptionDateOverride" ? "Inception Date Override" :
                      item.colId === "PrimaryClassification" ? "Primary Classification" :
                      item.colId === "SecondaryClassification" ? "Secondary Classification" :
                      item.colId === "UseAssetNameForPortfolio" ? "Use Asset Name For Portfolio" :
                      item.colId === "LinkingPortfolios" ? "Linking Portfolios" :
                      item.colId === "ClientStatementName" ? "Client Statement Name" : null,
                      minWidth: item.minwidth, maxWidth: item.maxwidth,
                    "tooltipField": item.colId === "PortfolioName" ? "PortfolioName" : item.colId === "AssetName" ? "AssetName" : item.colId === "ReportStrategyName" ? "ReportStrategyName"
                     : item.colId === "ReportSubStrategyName" ? "ReportSubStrategyName" : item.colId === "ClientStatementName" ? "ClientStatementName" : null,
                     cellStyle: { textAlign: (item.colId === "IsDefault" || item.colId === "IsAdvised" || item.colId === "IsSMA" || item.colId === "IsPerforming" || item.colId === "IsBillable" || item.colId === "HideDetails" || item.colId === "PrimaryCash" || item.colId === "Discretionary" || item.colId === "RegulatoryAum") ? "center " :null }

                }));
                formattedDef.push({ field: "Action", cellRenderer: ActionRenderer, maxWidth:100, filter: false });
                return { columns: formattedDef, filters: filterOptions };
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    };
    const fetchGridData = async () => {
        try {
            const customSettings = await getCustomSetting();
            const columns = customSettings?.columns.filter(item => item.colId !== "Action").map(item => ({ ...item }));
            setColDef(columns);
            setAppliedFilter(customSettings.filters);
        } catch (error) {
            console.error("Error fetching custom settings:", error);
        }
    };
    // get client statement List 
    const getClientStatementData = () => {
        sbaAxios({ url: getClientStatementAPI }).then(res => {
            setCSData(res);

        }).catch(e => {
            console.log(e, 'Error Loading the Client Statement Data');
            setCSData([]);
        })
    };

    // get ReportClassificationsAPI
    const GetReportClassificationsAPI = () => {
        sbaAxios({ url: getReportClassificationsAPI }).then(res => {
            setClassificationdata(res);

        }).catch(e => {
            console.log(e, 'Error Loading the Classification Data');
            setClassificationdata([]);
        })
    };

    // get Assets based on portfolio id
    const GetAsset = async (PortfolioId,ReportClassificationId) => {
        
        try {
            const response = await sbaAxios({
                url: `${getAssetWithoutReportSettings}/${PortfolioId},${ReportClassificationId}`,
                method: 'get',
            });
            if (response) {
                setAssetData(response);
            }
        }
        catch (e) {
            console.log(e, 'Error Fetching the  view data')
        };
    };
    // statergy 
    const Getstatergy = async (primaryid) => {
        try {
            const response = await sbaAxios({
                url: `${getClassificationItemsReportinsetting}/${primaryid}`,
                method: 'get',
            });
            if (response) {
                setstatergydata(response);
            }
        }
        catch (e) {
            console.log(e, 'Error Fetching the  view data')
        };
    };
    // sub statergy
    const Getsubstatergy = async (secondaryid) => {
        try {
            const response = await sbaAxios({
                url: `${getClassificationItemsReportinsetting}/${secondaryid}`,
                method: 'get',
            });
            if (response) {
                setsubstatergydata(response);
            }
        }
        catch (e) {
            console.log(e, 'Error Fetching the  view data')
        };
    };
    //Get Client Report settings
    const GetClientReportSettings = async (Portfolioid, ReportclassificationId) => {
        try {
            const response = await sbaAxios({ url: `${getClientReportSettings}/${Portfolioid},${ReportclassificationId}` });
            setGridData(response);
        } catch (error) {
            console.error("Error fetching custom settings:", error);
        }
    };

    // change events
    const portfoliochange = (e) => {
        if (e.value) {
            setselectedPortfolio(e.value);
            GetClientReportSettings(e.value.PortfolioId, selectedReportClassification.ReportClassificationId)
        }
    }

    const reportClassifichange = (e) => {
        if (e.value) {
            setselectedReportClassification(e.value);
            GetClientReportSettings(selectedPortfolio.PortfolioId, e.value.ReportClassificationId)
            Getstatergy(e.value.PrimaryParentClassId);
            Getsubstatergy(e.value.SecondaryParentClassId);
        }
    }

    const statergychange = (e) => {
        if (e.value) {
            setselectedstatergy(e.value);
        }
    }
    const substatergychange = (e) => {
        if (e.value) {
            setselectedsubstatergy(e.value);
        }
    }
    const drawerportfolioDDChng = (e) => {
        if (e.value) {
            setDrawerPortfolio(e.value);
            GetAsset(e.value.PortfolioId,selectedReportClassification.ReportClassificationId);
        }
    }
    const Assetchange = (e) => {
        if (e.value) {
            setselectedAsset(e.value);
        }
    }
    const Inceptionchange = (newDate) => {
        setNewDate(newDate);
    };
    const CSDatachange = (e) => {
        if (e.value) {
            setselectedCSData(e.value);
        }
    }
   
  return (
    <>
      <TopBar label={"Client Reporting Settings"} />
      <div className="mainContentData">
        <BreadCrumbs Levels={Level} />
        <div className="container-fluid">
          <div className="bg-white p-3 border rounded">
            <div className="d-flex gap-4">
              
                          <div className="mb-4 col-3">                                 
                  <label for="select fund" className="mb-1 ms-2 fw-semibold fs-12">Report Classification</label>
                                  <div>
                                      <SBAComboBox
                                      className="w-100"
                                      data={Classificationdata}
                                          value={selectedReportClassification}
                                      textField={"ReportClassification"}
                                      valueField={"ReportClassificationId"}
                                      onChange={reportClassifichange}
                                      popupSettings={{ className: "modalDD" }}
                                      placeholder="---Please Select---"
                                      />                                      
                                </div>                  
                          </div>

                <div className="mb-4 col-3">
                              <label for="select fund" className="mb-1 ms-2 fw-semibold fs-12">Portfolio</label>
                              <div>
                                  <SBAComboBox
                                      className="w-100"
                                      data={getPortfolioList}
                                      value={selectedPortfolio}
                                      textField={"Name"}
                                      valueField={"PortfolioId"}
                                      onChange={portfoliochange}
                                      popupSettings={{ className: "modalDD" }}
                                      placeholder="---Please Select---"
                                  />
                              </div>
                              </div>

                

                <div className="mb-4 row-items ms-auto">
                  <button
                    className="p-sm-btn mx-1 mt-4"
                    onClick={enterButtonClick}
                  >
                    Enter
                  </button>
                 <button
                   className="p-sm-btn mx-1 mt-4"
                   onClick={Addbuttonclk}
                    >
                   Add
                  </button>
                 </div>           
            </div>
                <SBGrid ref={usersLastLoginRef} column={colDef} row={GridData} pageSize={15} rowSelection="single" filters={appliedFilter} componentID={1021} gridStyle={{ width: '100%', height: '700px' }}></SBGrid>
          </div>
              </div>
              <SBADrawer
                  open={show}
                  setOpen={setshow}
                  close={false}
                  title={"Add /Edit Client Reporting Settings "}
              >
                  <div className="drawer">
                      <div>
                          <div className="col-lg-12 px-0">
                              <div className="row m-2">
                                  <div className="row mb-4">                                   
                                      <div className="col-md-5">
                                          <label className="mb-1 label">Portfolio<span class="mandatory">*</span></label>
                                          <div>
                                              <SBAComboBox
                                                  className="w-100"
                                                  data={getPortfolioList}
                                                  textField={"Name"}
                                                  valueField={"PortfolioId"}
                                                  onChange={drawerportfolioDDChng}
                                                  disabled={iseditable}
                                                  popupSettings={{ className: "modalDD" }}
                                                  value={DrawerPortfolio}
                                              />
                                          </div>
                                      </div>
                                      <div className="col-md-5">
                                          <label className="mb-1 label">Asset<span class="mandatory">*</span></label>
                                          <div>
                                              <SBAComboBox
                                                  className="w-100"
                                                  data={AssetData}
                                                  textField={"AssetName"}
                                                  valueField={"AssetId"}
                                                  popupSettings={{ className: "modalDD" }}
                                                  value={selectedAsset}
                                                  onChange={Assetchange}
                                                  disabled={iseditable}
                                              />
                                          </div>
                                      </div>
                                  </div>
                                  <div className="row mb-4">
                                      <div className="col-md-5">                                        
                                          <label className="mb-1 label">Primary Classification<span class="mandatory">*</span></label>
                                          <div>
                                              <SBAComboBox
                                                  className="w-100"
                                                  data={statergydata}
                                                  textField={"ClassificationValue"}
                                                  valueField={"ClassificationId"}
                                                  value={selectedstatergy}
                                                  popupSettings={{ className: "modalDD" }}
                                                  onChange={statergychange}
                                              />
                                          </div>
                                      </div>
                                      <div className="col-md-5">

                                          <label className="mb-1 label">Secondary Classification</label>
                                          <span class="mandatory">*</span>
                                          <div>
                                              <SBAComboBox
                                                  className="w-100"
                                                  data={substatergydata}
                                                  textField={"ClassificationValue"}
                                                  valueField={"ClassificationId"}
                                                  value={selectedsubstatergy}
                                                  popupSettings={{ className: "modalDD" }}
                                                  onChange={substatergychange}
                                              />
                                          </div>



                                         
                                      </div>
                                  </div>
                                  <div className="row mb-4">                                 
                                      <div className="col-md-5">
                                          <label className="header-container m-1">
                                              Asset Name Override
                                          </label>
                                          <div>
                                              <input
                                                  className="form-control w-100"
                                                  type="text"
                                                  value={selectedAssetnameoverride}
                                                  onChange={(e) => setselectedAssetnameoverride(e.target.value)}
                                                  
                                              />
                                          </div>
                                      </div>
                                      <div className="col-md-5">                                      
                                          <label className="mb-1 label">Inception Date Override</label>
                                          <div className="d-flex gap-2">
                                              <SBDatePicker
                                                  className="w-100"
                                                  id="inceptiondate"
                                                  defaultValue={newDate ? moment(newDate) : null}
                                                  onChange={Inceptionchange}
                                              />
                                          </div>
                                      </div>                                    
                                  </div>
                                  <div className="row mb-4">
                                      <div className="col-md-5">
                                          <label className="mb-1 label">Client StatementID</label>
                                          <div>
                                              <SBAComboBox
                                                  className="w-100"
                                                  data={CSData}
                                                  textField={"ClientStatementName"}
                                                  valueField={"ClientStatementId"}
                                                  value={selectedCSData}
                                                  popupSettings={{ className: "modalDD" }}
                                                  onChange={CSDatachange}
                                              />
                                          </div>
                                      </div>
                                      <div className="col-md-5">
                                          <label className="header-container m-1">
                                             Linking Portfolio
                                          </label>
                                          <div>
                                              <input
                                                  className="form-control w-100"
                                                  type="text"
                                                  value={selectedLinking}
                                                  onChange={(e) => setselectedLinking(e.target.value)}
                                              />
                                          </div>
                                      </div>
                                  </div>
                                  <div className="row mb-4">
                                      <div className="col-md-5">
                                          <label className="checkbox-label d-block">
                                              <input
                                                  type="checkbox"
                                                  className="checkbox-input"
                                                  name="Performing"
                                                  checked={Editdata.Performing}
                                                  onChange={(e) => {                                                   
                                                      setEditdata(prevData => ({
                                                          ...prevData,
                                                          Performing : e.target.checked
                                                          
                                                      }));
                                                  }}                                                                                                   
                                              />
                                              <span className="mx-2">Performing</span>
                                          </label>
                                      </div>
                                      <div className="col-md-5">
                                          <label className="checkbox-label d-block">
                                              <input
                                                  type="checkbox"
                                                  className="checkbox-input"
                                                  name="Billable"
                                                  checked={Editdata.Billable}
                                                  onChange={(e) => {
                                                      setEditdata(prevData => ({
                                                          ...prevData,
                                                          Billable: e.target.checked

                                                      }));
                                                  }}
                                              />
                                              <span className="mx-2">Billable</span>
                                          </label>
                                      </div>
                                  </div>
                                  <div className="row mb-4">
                                      <div className="col-md-5">
                                          <label className="checkbox-label d-block">
                                              <input
                                                  type="checkbox"
                                                  className="checkbox-input"
                                                  name="Advised"
                                                  checked={Editdata.Advised}
                                                  onChange={(e) => {
                                                      setEditdata(prevData => ({
                                                          ...prevData,
                                                          Advised: e.target.checked

                                                      }));
                                                  }}
                                              />
                                              <span className="mx-2">Advised</span>
                                          </label>
                                      </div>
                                      <div className="col-md-5">
                                          <label className="checkbox-label d-block">
                                              <input
                                                  type="checkbox"
                                                  className="checkbox-input"
                                                  name="Useasset"
                                                  checked={Editdata.Useasset}
                                                  onChange={(e) => {
                                                      setEditdata(prevData => ({
                                                          ...prevData,
                                                          Useasset: e.target.checked

                                                      }));
                                                  }}
                                              />
                                              <span className="mx-2">Use Asset Name For Portfolio</span>
                                          </label>
                                      </div>
                                  </div>
                                  <div className="row mb-4">
                                      <div className="col-md-5">
                                          <label className="checkbox-label d-block">
                                              <input
                                                  type="checkbox"
                                                  className="checkbox-input"
                                                  name="SMA"
                                                  checked={Editdata.Sma}
                                                  onChange={(e) => {
                                                      setEditdata(prevData => ({
                                                          ...prevData,
                                                          Sma: e.target.checked

                                                      }));
                                                  }}
                                              />
                                              <span className="mx-2">SMA</span>
                                          </label>
                                      </div>
                                      <div className="col-md-5">
                                          <label className="checkbox-label d-block">
                                              <input
                                                  type="checkbox"
                                                  className="checkbox-input"
                                                  name="HideDetails"
                                                  checked={Editdata.Hidedetails}
                                                  onChange={(e) => {
                                                      setEditdata(prevData => ({
                                                          ...prevData,
                                                          Hidedetails: e.target.checked

                                                      }));
                                                  }}
                                              />
                                              <span className="mx-2">Hide Details</span>
                                          </label>
                                      </div>
                                  </div>
                                  <div className="row mb-4">
                                      <div className="col-md-5">
                                          <label className="checkbox-label d-block">
                                              <input
                                                  type="checkbox"
                                                  className="checkbox-input"
                                                  name="Primary Cash"
                                                  checked={Editdata.Primarycash}
                                                  onChange={(e) => {
                                                      setEditdata(prevData => ({
                                                          ...prevData,
                                                          Primarycash: e.target.checked

                                                      }));
                                                  }}
                                              />
                                              <span className="mx-2">Primary Cash</span>
                                          </label>
                                      </div>
                                      <div className="col-md-5">

                                          <label className="checkbox-label d-block">
                                              <input
                                                  type="checkbox"
                                                  className="checkbox-input"
                                                  name="Discretionary"
                                                  checked={Editdata.Discretionary}
                                                  onChange={(e) => {
                                                      setEditdata(prevData => ({
                                                          ...prevData,
                                                          Discretionary: e.target.checked

                                                      }));
                                                  }}
                                              />
                                              <span className="mx-2">Discretionary</span>
                                          </label>


                                      </div>
                                  </div>



                                  <div className="row mb-4">
                                      <div className="col-md-5">
                                          <label className="checkbox-label d-block">
                                              <input
                                                  type="checkbox"
                                                  className="checkbox-input"
                                                  name="Regulatory AUM"
                                                  checked={Editdata.RegulatoryAum}
                                                  onChange={(e) => {
                                                      setEditdata(prevData => ({
                                                          ...prevData,
                                                          RegulatoryAum: e.target.checked

                                                      }));
                                                  }}
                                              />
                                              <span className="mx-2">Regulatory AUM</span>
                                          </label>
                                      </div>
                                      <div className="col-md-5">
                                      </div>
                                  </div>

                              </div>
                          </div>
                          <div className="mt-5">
                              <button className="s-sm-btn mx-1" onClick={() => {
                                  setshow(false);
                              }}>
                                  Cancel
                            </button>
                              <button className="p-sm-btn mx-1" onClick={SaveReportsettings}>
                                  Save
                           </button>
                          </div>
                      </div>
                  </div>
              </SBADrawer>

              {/* View Delete Modal ----- */}
              <Modal show={showdeleteModal}>
                  <Modal.Header
                      closeButton
                      onClick={() => {
                          setShowdeleteModal(false);
                      }}
                  >
                      <Modal.Title>
                          Delete Client Report Settings
          </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                      <p>Do you want delete this Client Report Settings?</p>
                  </Modal.Body>
                  <Modal.Footer>
                      <button
                          className="s-sm-btn mx-1"
                          onClick={() => {
                              setShowdeleteModal(false);
                          }}
                      >
                          Cancel
                       </button>
                      <button
                          className="p-sm-btn mx-1"
                          onClick={Deletesettings}
                      >
                          Yes
                    </button>
                  </Modal.Footer>
              </Modal>
              <ToastContainer></ToastContainer>
      </div>
    </>
  );
};
const Editflages = {
    "Performing": false,
    "Billable": false,
    "Advised": false,
    "Useasset": false,
    "Sma": false,
    "Hidedetails": false,
    "Primarycash": false,
    "IsDefault":true,
    "RegulatoryAum":false,
    "Discretionary": false,


}